import React, { useState } from 'react';

import {
  CmBox,
  CmButton,
  CmLabelAndInput,
  CmLabelAndPasswordInput,
  CmLink,
  CmText,
  CmVStack,
} from '@/components/uiParts';
import { useInput } from '@/hooks/Form';
import { routes } from '@/router';

interface Props {
  onSubmit: (email: string, password: string) => Promise<void>;
}

export const Form: React.FC<Props> = ({ onSubmit }): JSX.Element => {
  const [isShow, setIsShow] = useState<boolean>(false);
  const [email, emailProps] = useInput('', 'email');
  const [password, passwordProps] = useInput('', isShow ? 'text' : 'password');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    await onSubmit(email, password);
  };

  return (
    <CmBox as="form" mx={4} onSubmit={handleSubmit}>
      <CmVStack spacing={'4'}>
        <CmLabelAndInput
          label={'メールアドレス'}
          id={'email'}
          {...emailProps}
        />
        <CmLabelAndPasswordInput
          label={'パスワード'}
          id={'password'}
          handleShowPassword={() => setIsShow(!isShow)}
          {...{ ...passwordProps, isShow }}
        />
      </CmVStack>
      {/*
       // @ts-ignore TS2590 */}
      <CmButton mt="8" type="submit" width="100%">
        ログイン
      </CmButton>
      <CmBox textAlign="right" mt="1">
        <CmLink to={routes.ForgotPassword.path} display="inline-box">
          <CmText fontSize="sm">パスワードをお忘れですか？</CmText>
        </CmLink>
      </CmBox>
    </CmBox>
  );
};
